<template>
  <div class="popup-redirect">
    <div class="popup-redirect__progress" v-if="currentTime" >
      <div class="circular-progress">
        <svg data-v-54e3b0ac=""
             xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 40 40"
             aria-labelledby="title"
             role="graphic">
          <circle
            data-v-54e3b0ac=""
            cx="18.75"
            cy="18.75"
            r="17.5"
            stroke-width="2.5">
          </circle>
          <circle
            data-v-54e3b0ac=""
            cx="18.75"
            cy="18.75"
            r="17.5"
            stroke-width="2.5"
            id="pct-ind"
            :style="`stroke-dasharray: ${strokeDash};`">
          </circle>
        </svg>
        <p class="circular-progress__text">{{ currentTime ? currentTime : '' }}</p>
      </div>
    </div>
    <div class="popup-redirect__action">
      <div v-if="currentTime">
        <div class="popup-redirect__text" >
          {{ $t('bookingPopup.popup.redirect.textFirst') }}
        </div>
      </div>
      <div
        v-else
        class="popup-redirect__btn-block"
      >
        <div class="popup-redirect__text" >
          {{ $t('bookingPopup.popup.redirect.textSecond') }}
        </div>
        <yt-button
          class="popup-redirect__submit"
          color="green"
          :squared="true"
          @click="submitPopup"
        >
          {{ $t('bookingPopup.popup.redirect.btn') }}
        </yt-button>
      </div>
    </div>
  </div>
</template>

<script>

import YtButton from "@/components/ui-kit/yt-button"
export default {
  components: {
    YtButton
  },
  data() {
    return {
      currentTime: 5,
      timer: null,
      strokeOffset: 109.96,
      strokeDash: 219
    }
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        this.currentTime--;
        if(this.currentTime == 1) {
          this.$emit('redirect-submit');
        }
      }, 1000)
    },
    stopTimer() {
      clearTimeout(this.timer)
    },
    submitPopup(){
      this.$emit('redirect-submit');
    }
  },
  mounted() {
    setTimeout(()=> {this.strokeDash = this.strokeOffset;}, 100);
    this.startTimer();
    this.$emit('loaded');
  },
  destroyed() {
    this.stopTimer()
  },
  watch: {
    currentTime(time) {
      if (time === 0) {
        this.stopTimer()
      }
    }
  },
}
</script>

<style  lang="scss" scoped>
.popup-redirect{
  display: flex;
  align-items: center;
  flex-direction: column;


  &__progress {
    position: relative;
    height: 40px;
    width: 40px;
    margin-bottom: 22px;
  }

  &__text {
    text-align: center;
    max-width: 271px;
  }

  &__submit {
    margin-top: 28px;
  }
  &__btn-block{
    display: flex;
    flex-direction: column;
  }
}
.circular-progress {
  position: absolute;
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;

  &__text {
     position: absolute;
     top: 57%;
     left: 47%;
     transform: translate( -50% , -50% );
     color: #9AAE2D;
     font-size: 18px;
   }
}

circle {
  stroke-width: 2.5;
  fill: none;
  stroke-linecap: square;
}

circle:nth-of-type(1) {
  stroke: transparent;
}

circle:nth-of-type(2) {
  stroke: #ABC232;
  stroke-dashoffset: 109;
  stroke-linecap: round;
  transition: all 5s linear
}
</style>
